// extracted by mini-css-extract-plugin
export default {"resizable":"resizable--ipg4w","details":"details--giGlN"};